import React from "react"

export type SDT = React.Dispatch<React.SetStateAction<FiltersState>>

export interface FiltersApi {
  getValues: () => any;
  setValues: (values: any) => void;
  resetValues: () => void;
}
export class FiltersState {
  values: any = {};
}
